function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function (_typeof2) { function _typeof(_x) { return _typeof2.apply(this, arguments); } _typeof.toString = function () { return _typeof2.toString(); }; return _typeof; }(function (obj) { return typeof obj; }); } else { _typeof = function (_typeof3) { function _typeof(_x2) { return _typeof3.apply(this, arguments); } _typeof.toString = function () { return _typeof3.toString(); }; return _typeof; }(function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }); } return _typeof(obj); }

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import Component from 'vue-class-component';
import { VueComponent } from '@progress/kendo-vue-common';
import { GridColumnMenuFilterCell } from './GridColumnMenuFilterCell'; // import { DropDownList } from '@progress/kendo-vue-dropdowns';

/**
 * @hidden
 */

var GridColumnMenuFilterUI =
/** @class */
function (_super) {
  __extends(GridColumnMenuFilterUI, _super);

  function GridColumnMenuFilterUI() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  GridColumnMenuFilterUI.prototype.changeHandler = function (e, filterIndex) {
    this.$emit('change', e, filterIndex);
  };

  GridColumnMenuFilterUI.prototype.logicChange = function (e) {
    this.$emit('logicChange', e);
  };
  /**
   * @hidden
   */
  // @ts-ignore


  GridColumnMenuFilterUI.prototype.render = function (h) {
    var _this = this;

    var _a = this.$props,
        firstFilterProps = _a.firstFilterProps,
        hideSecondFilter = _a.hideSecondFilter,
        secondFilterProps = _a.secondFilterProps,
        logicData = _a.logicData,
        logicValue = _a.logicValue,
        operators = _a.operators,
        render = _a.render;

    var optionMapper = function optionMapper(items, selected) {
      return items.map(function (item) {
        if (selected && item.operator === selected.operator) {
          return h("option", {
            domProps: {
              "value": item.operator
            },
            attrs: {
              selected: true
            }
          }, [item.text]);
        } else {
          return h("option", {
            domProps: {
              "value": item.operator
            }
          }, [item.text]);
        }
      });
    };

    var firstField = firstFilterProps.field,
        firstValue = firstFilterProps.value,
        firstOperator = firstFilterProps.operator,
        firstFilterType = firstFilterProps.filterType,
        secondField = secondFilterProps.field,
        secondValue = secondFilterProps.value,
        secondOperator = secondFilterProps.operator,
        secondFilterType = secondFilterProps.filterType;
    var defaultRendering = h("div", [h(GridColumnMenuFilterCell, {
      attrs: {
        field: firstField,
        value: firstValue,
        operator: firstOperator,
        filterType: firstFilterType,
        operators: operators
      },
      on: {
        "change": function change(e) {
          _this.changeHandler(e, 0);
        }
      }
    }), !hideSecondFilter && h("div", [h("select", {
      attrs: {
        tabIndex: 0
      },
      on: {
        "change": this.logicChange
      },
      "class": "k-textbox k-filter-and"
    }, [optionMapper(logicData, logicValue)]), h(GridColumnMenuFilterCell, {
      attrs: {
        field: secondField,
        value: secondValue,
        operator: secondOperator,
        filterType: secondFilterType,
        operators: operators
      },
      on: {
        "change": function change(e) {
          _this.changeHandler(e, 1);
        }
      }
    })])]);

    if (render) {
      var events = __assign({
        change: this.changeHandler,
        logicchange: this.logicChange
      }, this.$props.render.listeners);

      if (render.type === 'slot') {
        return render.render({
          props: this.$props,
          listeners: events,
          methods: events
        });
      } else if (render.type === 'renderFunction') {
        return render.render(h, defaultRendering, this.$props, events);
      } else {
        return h(render.render, {
          props: this.$props,
          on: events
        });
      }
    } else {
      return defaultRendering;
    }
  };

  GridColumnMenuFilterUI = __decorate([Component({
    props: {
      firstFilterProps: Object,
      secondFilterProps: Object,
      logicValue: Object,
      logicData: Array,
      hideSecondFilter: Boolean,
      operators: Array,
      render: [String, Function, Object]
    }
  })], GridColumnMenuFilterUI);
  return GridColumnMenuFilterUI;
}(VueComponent);

export { GridColumnMenuFilterUI };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-vue-grid/dist/es/columnMenu/GridColumnMenuFilterUI.js
// module id = null
// module chunks = 